import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeletePersonnelAssessmentMutation } from "../../services/appln";

export default function DeletePersonnelAssessment(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeletePersonnelAssessmentMutation}
      deleteArgs={{ ...props }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deletePersonnelAssessmentTitle}
      confirmationDialogMsg={strings.deletePersonnelAssessmentConfirmation}
      errorDialogTitle={strings.deletePersonnelAssessmentFailedTitle}
      errorDialogMsg={strings.deletePersonnelAssessmentFailedMsg}
    />
  );
}
